<template>
    <transition :name="transition">
        <slot></slot>
    </transition>
</template>

<script>
    export default {
        name: "SwipeTransition",
        data() {
            return {
                transition: 'swipe-right'
            }
        },
        watch: {
            $route() {
                this.transition = this.$router.history.router.direction == 'forward' ? 'swipe-right' : 'swipe-left'
            }
        }
    }
</script>

<style scoped>

</style>